import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FiltersAthleteGeneralService } from '../../../services/filters-athlete-general.service';
import { IAthleteBiography } from '../../../../common-page-components/stores/entities-store/athlete-biography-store';
import { Subscription } from 'rxjs';
import { tap, filter } from 'rxjs/operators';

@Component({
  selector: 'app-bootstrap-athlete-statistics',
  templateUrl: './bootstrap-athlete-statistics.component.html',
  styleUrls: ['./bootstrap-athlete-statistics.component.scss']
})
export class BootstrapAthleteStatisticsComponent implements OnInit, OnDestroy {

  /**
   * Athlete value for set the loading.
   *
   * @type {IAthleteBiography}
   * @memberof BootstrapAthleteStatisticsComponent
   */
  athlete: IAthleteBiography;

  /**
   * Subscription array for unsubscribe in destroy.
   *
   * @type {Array<Subscription>}
   * @memberof BootstrapAthleteStatisticsComponent
   */
  subscription: Array<Subscription> = [];

  constructor(private common_service: FiltersAthleteGeneralService, private chg: ChangeDetectorRef) {

  }

  /**
   *{@inheritdoc}
   *
   * @memberof BootstrapAthleteStatisticsComponent
   */
  ngOnInit() {
    // We call the service for set the athlete and the routing logic.
    this.subscription.push(this.common_service.athleteDetailStore.dataStream.pipe(
      filter(a => a != undefined),
      tap(a => this.chg.detectChanges())).subscribe(next => this.athlete = next)
    );
  }

  /**
   * {@inheritdoc}
   *
   * @memberof BootstrapAthleteStatisticsComponent
   */
  ngOnDestroy(): void {
    this.subscription.forEach(value => value.unsubscribe());

  }

}
